import {
  LinkOwnershipButton,
  OpportunityModeIndexMapper,
  TheaterTypeIndexMapper,
} from '@liveoptics/project.ownership.react-ui';
import React from 'react';
import { createRoot } from 'react-dom/client';

export const renderLinkOwnershipButton = (element: HTMLElement, wrapper: HTMLElement) => {
  const projectIdValue = element?.getAttribute('data-projectid');
  const defaultTheaterValue = element?.getAttribute('default-theater');
  const userRoleValue = element?.getAttribute('user-role');
  const ownershipVerifiedValue = element?.getAttribute('data-isverified');
  const ownerIdValue = element?.getAttribute('owner-id');
  const projectStatusValue = element?.getAttribute('project-status');
  const ownerCompanySfdcAccountIdValue = element?.getAttribute('data-companysfdcaccountid');
  const ownerCompanySfdcAccountNameValue = element?.getAttribute('data-companysfdcaccountname');
  const projectSfdcAccountIdValue = element?.getAttribute('data-projectsfdcaccountid');
  const projectSfdcAccountNameValue = element?.getAttribute('data-projectsfdcaccountname');
  const opportunityIdValue = element?.getAttribute('data-sfdcdealid');
  const opportunityModeValue = element?.getAttribute('data-dealmode');
  const dealIdValue = element?.getAttribute('data-projectdealid');
  if (
    element &&
    projectIdValue &&
    defaultTheaterValue &&
    userRoleValue &&
    ownershipVerifiedValue &&
    ownerIdValue != null &&
    projectStatusValue
  ) {
    if (element.id !== 'link-ownership-button' && element.className !== 'link-ownership-button') {
      const parent = element.parentElement;
      const newElement = document.createElement('div');
      parent?.replaceChild(newElement, element);
      newElement.id = 'link-ownership-button';
      newElement.className = 'link-ownership-button';
      newElement.style.padding = '0px';
      const root = createRoot(newElement);
      root.render(
        <React.StrictMode>
          <LinkOwnershipButton
            projectId={parseInt(projectIdValue)}
            defaultTheater={TheaterTypeIndexMapper[parseInt(defaultTheaterValue)]}
            userRole={userRoleValue}
            ownershipVerified={JSON.parse(ownershipVerifiedValue.toLowerCase())}
            ownerId={Number(ownerIdValue)}
            projectStatus={projectStatusValue}
            ownerCompanySfdcAccountId={ownerCompanySfdcAccountIdValue ?? undefined}
            ownerCompanySfdcAccountName={ownerCompanySfdcAccountNameValue ?? undefined}
            projectSfdcAccountId={projectSfdcAccountIdValue ?? undefined}
            projectSfdcAccountName={projectSfdcAccountNameValue ?? undefined}
            opportunityId={opportunityIdValue ? parseInt(opportunityIdValue) : undefined}
            opportunityMode={
              opportunityModeValue
                ? OpportunityModeIndexMapper[parseInt(opportunityModeValue)]
                : undefined
            }
            dealId={dealIdValue ?? undefined}
            onSuccess={() =>
              wrapper.dispatchEvent(
                new CustomEvent('project-verified', {
                  bubbles: true,
                  detail: { isVerified: true },
                })
              )
            }
          />
        </React.StrictMode>
      );
    }
  } else {
    if (element.id !== 'link-ownership-button' && element.className !== 'link-ownership-button') {
      const parent = element.parentElement;
      const newElement = document.createElement('div');
      parent?.replaceChild(newElement, element);
      newElement.id = 'link-ownership-button';
      newElement.className = 'link-ownership-button';
      newElement.style.padding = '0px';
      const root = createRoot(newElement);
      root.render(
        <React.StrictMode>
          <></>
        </React.StrictMode>
      );
    }
  }
};
